export const ADD_CONTRACTS = 'ADD_CONTRACTS'
export const ADD_CONTRACT = 'ADD_CONTRACT'
export const ADD_CONTRACT_TYPE_ENUM = 'ADD_CONTRACT_TYPE_ENUM'
